<!--资源中心-->
<template>
    <div class="container">
        <homeHead ref="homeHead" />
        <div class="rc-page">
            <!--卡片导航视图-->
            <template v-if="viewMode === 'cards'">
                <!--中心切换 Tab-->
                <div class="tab-row">
                    <div v-for="t in tabs" :key="t.key"
                         :class="['tab-pill', activeTab === t.key ? 'tab-active' : '']"
                         @click="activeTab = t.key">{{ t.label }}</div>
                </div>

                <!--学校文化中心-->
                <div v-if="activeTab === 'school'" class="panel">
                    <div class="panel-title"><span class="star">✦</span> 校园文化中心</div>
                    <div class="school-card-row">
                        <div class="sc-card" v-for="c in schoolCards" :key="c.title" @click="openCard(c)">
                            <div class="sc-title">{{ c.title }}</div>
                            <div class="sc-desc">{{ c.desc }}</div>
                            <img class="sc-icon" :src="c.icon" alt="">
                            <div class="pill-btn">{{ c.btn }}</div>
                        </div>
                    </div>
                </div>

                <!--教师发展中心-->
                <div v-if="activeTab === 'teacher'" class="teacher-wrap">
                    <!--课程开发与示范-->
                    <div class="panel teach-panel">
                        <div class="panel-title panel-title-left"><span class="star">✦</span> 课程开发与示范</div>
                        <div class="teach-grid">
                            <div class="sc-card gsp-card" @click="openCard(teacherMain)">
                                <div class="sc-title">{{ teacherMain.title }}<span class="hot-tag">热门</span></div>
                                <div class="sc-desc">{{ teacherMain.desc }}</div>
                                <img class="sc-icon" :src="teacherMain.icon" alt="">
                                <div class="pill-btn">{{ teacherMain.btn }}</div>
                            </div>
                            <div class="teach-sub">
                                <div class="sc-card sub-card" v-for="c in teacherSubs" :key="c.title" @click="openCard(c)">
                                    <div class="sc-title">{{ c.title }}<span class="hot-tag">热门</span></div>
                                    <div class="sc-desc">{{ c.desc }}</div>
                                    <img class="sub-icon" :src="c.icon" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="teach-right">
                        <!--互动课件/精准助教-->
                        <div class="panel tool-panel">
                            <div class="tool-card" v-for="c in teacherTools" :key="c.title" @click="openCard(c)">
                                <div class="kh-info">
                                    <div class="kh-title">{{ c.title }}</div>
                                    <div class="kh-desc">{{ c.desc }}</div>
                                </div>
                                <img class="tool-icon" :src="c.icon" alt="">
                            </div>
                        </div>
                        <div class="teach-bottom">
                            <!--国家智慧教育云平台 + 课后服务-->
                            <div class="cloud-col">
                                <!--国家智慧教育云平台-->
                                <div class="cloud-card" @click="openCard(cloudCard)">
                                    <div class="cloud-title">{{ cloudCard.title }}</div>
                                    <div class="cloud-desc">{{ cloudCard.desc }}</div>
                                </div>
                                <!--课后服务-->
                                <div class="khfw-card" @click="openCard(khfwCard)">
                                    <div class="khfw-title">{{ khfwCard.title }}</div>
                                </div>
                            </div>
                            <!--小初高资源-->
                            <div class="res-col">
                                <div class="res-card" v-for="c in levelCards" :key="c.title" @click="openCard(c)">
                                    <div class="kh-info">
                                        <div class="kh-title">{{ c.title }}</div>
                                        <div class="kh-desc">{{ c.desc }}</div>
                                    </div>
                                    <img class="res-icon" :src="c.icon" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!--学生成长中心-->
                <div v-if="activeTab === 'student'" class="student-wrap">
                    <!--自习室 / 作业管理-->
                    <div class="sc-card stu-card" v-for="c in studentSingles" :key="c.title" @click="openCard(c)">
                        <div class="sc-title text-center">{{ c.title }}</div>
                        <div class="stu-icon-wrap">
                            <div class="stu-icon" :class="c.iconClass">{{ c.iconText }}</div>
                        </div>
                        <div class="pill-btn">{{ c.btn }}</div>
                    </div>
                    <!--右侧功能面板-->
                    <div class="panel stu-panel">
                        <div class="stu-top">
                            <div class="stu-v-card" v-for="c in studentVertical" :key="c.title" @click="openCard(c)">
                                <div class="stu-v-title">{{ c.title }}</div>
                                <div class="pill-btn pill-btn-xs">{{ c.btn }}<span class="arr">›</span></div>
                            </div>
                            <div class="stu-wide-card" @click="openCard(studentWide)">
                                <div class="stu-wide-title">{{ studentWide.title }}</div>
                                <div class="stu-card-bottom">
                                    <div class="pill-btn pill-btn-xs">{{ studentWide.btn }}<span class="arr">›</span></div>
                                    <div class="stu-icon" :class="studentWide.iconClass"></div>
                                </div>
                            </div>
                        </div>
                        <div class="stu-bottom">
                            <div class="stu-plan-card" v-for="c in studentPlans" :key="c.title" @click="openCard(c)">
                                <div class="stu-plan-title" :class="c.titleClass">{{ c.title }}</div>
                                <div class="stu-card-bottom">
                                    <div class="pill-btn pill-btn-xs">{{ c.btn }}<span class="arr">›</span></div>
                                    <div class="stu-icon" :class="c.iconClass">{{ c.iconText }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>

            <!--模块视图-->
            <template v-else>
                <div class="back-row">
                    <div class="back-btn" @click="backToCards">
                        <el-icon><ArrowLeft /></el-icon>返回
                    </div>
                    <!--圈考点：标题与返回按钮同行显示-->
                    <div v-if="activeItem==='37'" class="back-row-title"><span class="star">✦</span> 圈考点</div>
                    <!--热搜题：标题与返回按钮同行显示-->
                    <div v-if="activeItem==='38'" class="back-row-title"><span class="star">✦</span> 热搜题</div>
                    <!--分层作业：标题与返回按钮同行显示-->
                    <div v-if="activeItem==='39'" class="back-row-title"><span class="star">✦</span> 分层作业</div>
                    <!--英语强化：标题与返回按钮同行显示-->
                    <div v-if="activeItem==='40'" class="back-row-title"><span class="star">✦</span> 英语强化</div>
                    <!--赢在规划：标题与返回按钮同行显示-->
                    <div v-if="activeItem==='41'" class="back-row-title"><span class="star">✦</span> 赢在规划</div>
                    <!--赢在录取：标题与返回按钮同行显示-->
                    <div v-if="activeItem==='42'" class="back-row-title"><span class="star">✦</span> 赢在录取</div>
                    <!--素材中心：标题与返回按钮同行显示-->
                    <div v-if="activeItem==='43'" class="back-row-title"><span class="star">✦</span> 校园文化</div>
                    <!--赢在录取：子模块Tab，靠右显示-->
                    <div v-if="activeItem==='42'" class="back-row-tabs">
                        <div :class="['tab-pill', enrollActiveTab==='major' ? 'tab-active' : '']"
                             @click="enrollActiveTab='major'">学霸讲专业</div>
                        <div :class="['tab-pill', enrollActiveTab==='know' ? 'tab-active' : '']"
                             @click="enrollActiveTab='know'">专业知晓</div>
                    </div>
                </div>
                <div class="module-content">
                    <!--高水平示范课-->
                    <div v-if="activeItem==='1'">
                        <page-course title="高水平示范课"
                                     courseType="1"
                                     :course-mode="this.activeMode"
                                     @change-mode="changeMode"/>
                    </div>
                    <!--区本课程-->
                    <div v-if="activeItem==='2'">
                        <page-course title="区本课程"
                                     courseType="2"
                                     :course-mode="this.activeMode"
                                     @change-mode="changeMode"/>
                    </div>
                    <!--校本课程-->
                    <div v-if="activeItem==='3'">
                        <page-course title="校本课程"
                                     courseType="3"
                                     :course-mode="this.activeMode"
                                     @change-mode="changeMode"/>
                    </div>
                    <!--课后服务-->
                    <div v-if="activeItem==='4'">
                        <page-service-course title="课后服务"
                                     courseType="4"
                                     :course-mode="this.activeMode"
                                     @change-mode="changeMode"/>
                    </div>
                    <!--人工智能-->
                    <div v-if="activeItem==='5'">
                        <page-course title="人工智能"
                                     courseType="5"
                                     :course-mode="this.activeMode"
                                     @change-mode="changeMode"/>
                    </div>
                    <!--互动课件-->
                    <div v-if="activeItem==='6'">
                        <courseware-list title="互动课件"
                                         :course-mode="this.activeMode"
                                         @change-mode="changeMode"/>
                    </div>
                    <!--人文美育-->
                    <div v-if="activeItem==='8'">
                        <humanity-museum-home title="人文美育"
                                         :course-mode="this.activeMode"
                                         @change-mode="changeMode"/>
                    </div>
                    <!--党建引领-->
                    <div v-if="activeItem==='10'">
                        <djyl-resource-new title="党建引领"
                                       :course-mode="this.activeMode"
                                       @change-mode="changeMode"/>
                    </div>
                    <!--政策法规-->
                    <div v-if="activeItem==='11'">
                        <zcfg-resource title="政策法规"
                                       :course-mode="this.activeMode"
                                       @change-mode="changeMode"/>
                    </div>
                    <!--五馆合一-旧-->
                    <div v-if="activeItem==='12'">
                        <humanity-five-museum title="五馆合一"
                                              :course-mode="this.activeMode"
                                              @change-mode="changeMode"/>
                    </div>
                    <!--跨学科融合-->
                    <div v-if="activeItem==='13'">
                        <humanity-subject-museum title="跨学科融合"
                                              :course-mode="this.activeMode"
                                              @change-mode="changeMode"/>
                    </div>
                    <!--美育浸润-->
                    <div v-if="activeItem==='14'">
                        <home-myjr title="美育浸润"
                                   :course-mode="this.activeMode"
                                   @change-mode="changeMode"/>
                    </div>
                    <!--精准阅读-->
                    <div v-if="activeItem==='15'">
                        <home-read title="精准阅读"
                                   :course-mode="this.activeMode"
                                   @change-mode="changeMode"/>
                    </div>
                    <!--幼儿园资源-->
                    <div v-if="activeItem==='20'">
                        <yey-resource-home />
                    </div>
                    <!--初中题库（日清周结）-->
                    <div v-if="activeItem==='24'">
                        <rqzj-home title="日清周结"
                                   :course-mode="this.activeMode"
                                   @change-mode="changeMode"/>
                    </div>
                    <!--高中题库（三层量分定做）-->
                    <div v-if="activeItem==='25'">
                        <sclfdz-home title="三层量分定做"
                                     :course-mode="this.activeMode"
                                     @change-mode="changeMode"/>
                    </div>
                    <!-- 新五馆合一-->
                    <div v-if="activeItem==='30'">
                        <new-five-museum
                                      :course-mode="this.activeMode"
                                      @change-mode="changeMode"/>
                    </div>
                    <!-- 新五馆-阅读拓展馆-->
                    <div v-if="activeItem==='31'">
                        <read-extension-museum
                          :course-mode="this.activeMode"
                          :is-show-back="false"
                          @change-mode="changeMode"/>
                    </div>
                    <!-- 新五馆-科技艺术馆-->
                    <div v-if="activeItem==='32'">
                        <tech-art-museum
                          :course-mode="this.activeMode"
                          :is-show-back="false"
                          @change-mode="changeMode"/>
                    </div>
                    <!-- 新五馆-非遗文化馆-->
                    <div v-if="activeItem==='33'">
                        <intangible-museum
                          :course-mode="this.activeMode"
                          :is-show-back="false"
                          @change-mode="changeMode"/>
                    </div>
                    <!-- 新五馆-劳动实践营-->
                    <div v-if="activeItem==='34'">
                        <labor-practice-museum
                          :course-mode="this.activeMode"
                          :is-show-back="false"
                          @change-mode="changeMode"/>
                    </div>
                    <!-- 新五馆-自然研学馆-->
                    <div v-if="activeItem==='35'">
                        <nature-study-museum
                          :course-mode="this.activeMode"
                          :is-show-back="false"
                          @change-mode="changeMode"/>
                    </div>
                    <!-- 最美课本-博雅大语文-->
                    <div v-if="activeItem==='36'">
                        <boyaa-chinese @back-read-museum="backToCards"/>
                    </div>
                    <!--圈考点-->
                    <div v-if="activeItem==='37'">
                        <exam-point-home ref="examPointHome"
                                         title="圈考点"
                                         :course-mode="this.activeMode"
                                         @change-mode="changeMode"/>
                    </div>
                    <!--热搜题-->
                    <div v-if="activeItem==='38'">
                        <hot-ques-home ref="hotQuesHome"
                                       title="热搜题"
                                       :course-mode="this.activeMode"
                                       @change-mode="changeMode"/>
                    </div>
                    <!--分层作业-->
                    <div v-if="activeItem==='39'">
                        <homework-home ref="homeworkHome"
                                       title="分层作业"
                                       :course-mode="this.activeMode"
                                       @change-mode="changeMode"/>
                    </div>
                    <!--英语强化-->
                    <div v-if="activeItem==='40'">
                        <english-improve-home ref="englishImproveHome"
                                              title="英语强化"
                                              :course-mode="this.activeMode"
                                              @change-mode="changeMode"/>
                    </div>
                    <!--赢在规划-->
                    <div v-if="activeItem==='41'">
                        <admission-home ref="admissionHome"
                                        title="赢在规划"
                                        :course-mode="this.activeMode"
                                        @change-mode="changeMode"/>
                    </div>
                    <!--赢在录取-->
                    <div v-if="activeItem==='42'">
                        <win-enroll-home ref="winEnrollHome"
                                         title="赢在录取"
                                         :active-tab="enrollActiveTab"
                                         :course-mode="this.activeMode"
                                         @change-mode="changeMode"/>
                    </div>
                    <!--素材中心-->
                    <div v-if="activeItem==='43'">
                        <material-home ref="materialHome"
                                       title="校园文化"
                                       :course-mode="this.activeMode"
                                       @change-mode="changeMode"/>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>
<script>
import homeHead from "@/components/homeHead.vue";
import pageCourse from "@/components/resourceCentre/pageCourse.vue";
import pageServiceCourse from "@/components/resourceCentre/pageServiceCourse.vue";
import coursewareList from "@/components/resourceCentre/coursewareList";
import humanityMuseumHome from "@/components/resourceCentre/humanityMuseumHome";
import humanityFiveMuseum from "@/components/resourceCentre/humanityFiveMuseum.vue";
import humanitySubjectMuseum from "@/components/resourceCentre/humanitySubjectMuseum.vue";
import zcfgResource from "@/components/resourceCentre/zcfgResource.vue";
import DjylResourceNew from "@/components/resourceCentre/djylResourceNew.vue";
import homeMyjr from "@/components/myjr/homeMyjr.vue";
import homeRead from "@/components/read/homeRead.vue";
import newFiveMuseum from "@/components/newMuseum/newFiveMuseum.vue";
import readExtensionMuseum from "@/components/newMuseum/readExtensionMuseum.vue";
import techArtMuseum from "@/components/newMuseum/techArtMuseum.vue";
import intangibleMuseum from "@/components/newMuseum/intangibleMuseum.vue";
import laborPracticeMuseum from "@/components/newMuseum/laborPracticeMuseum.vue";
import natureStudyMuseum from "@/components/newMuseum/natureStudyMuseum.vue";
import boyaaChinese from "@/components/newMuseum/read/boyaaChinese.vue";
import rqzjHome from "@/components/rqzj/rqzjHome.vue";
import sclfdzHome from "@/components/sclfdz/sclfdzHome.vue";
import yeyResourceHome from "@/components/resourceCentre/yeyResourceHome.vue";
import examPointHome from "@/components/examPoint/examPointHome.vue";
import hotQuesHome from "@/components/hotQues/hotQuesHome.vue";
import homeworkHome from "@/components/homework/homeworkHome.vue";
import englishImproveHome from "@/components/englishImprove/englishImproveHome.vue";
import admissionHome from "@/components/admission/admissionHome.vue";
import winEnrollHome from "@/components/winEnroll/winEnrollHome.vue";
import materialHome from "@/components/material/materialHome.vue";
import {oauthCode} from "@/api/user/login";

export default {
    components: {
        boyaaChinese,
        natureStudyMuseum,
        laborPracticeMuseum,
        intangibleMuseum,
        techArtMuseum,
        DjylResourceNew,
        pageCourse,
        homeHead,
        coursewareList,
        humanityMuseumHome,
        humanityFiveMuseum,
        humanitySubjectMuseum,
        pageServiceCourse,
        zcfgResource,
        homeMyjr,
        homeRead,
        newFiveMuseum,
        readExtensionMuseum,
        rqzjHome,
        sclfdzHome,
        yeyResourceHome,
        examPointHome,
        hotQuesHome,
        homeworkHome,
        englishImproveHome,
        admissionHome,
        winEnrollHome,
        materialHome
    },
    name: "homeResourceCentre",
    data() {
        return {
            pageMode:"page",
            activePath: "homeResourceCentre",
            activeItem:"2",
            activeMode:"page",
            userInfo: {},
            /*视图模式：cards-卡片导航 module-资源模块*/
            viewMode: "cards",
            /*当前中心Tab*/
            activeTab: "school",
            /*进入模块前的来源Tab（返回卡片导航时优先回到该Tab）*/
            fromTab: null,
            /*赢在录取子模块Tab：major-学霸讲专业 know-专业知晓*/
            enrollActiveTab: 'major',
            tabs: [
                { key: 'school', label: '学校文化中心' },
                { key: 'teacher', label: '教师发展中心' },
                { key: 'student', label: '学生成长中心' },
            ],
            /*学校文化中心*/
            schoolCards: [
                { title: '党建引领', desc: '筑牢思想根基，汲取奋进力量', icon: require('../../assets/screen/Group 134.png'), btn: '去学习', item: '10' },
                { title: '政策法规', desc: '精准解读政策，明晰教育航向', icon: require('../../assets/screen/Group 135.png'), btn: '去解读', item: '11' },
                { title: '五馆合一', desc: '涵养人文底蕴，提升审美素养', icon: require('../../assets/screen/Group 136.png'), btn: '去体验', item: '30' },
                { title: '校园文化', desc: '汇聚优质资源，助力教学创新', icon: require('../../assets/screen/Group 131.png'), btn: '去获取', item: '43' },
            ],
            /*教师发展中心*/
            teacherMain: { title: '高水平示范课', desc: '已训练最新教材内容，内容更贴切课本内容', icon: require('../../assets/screen/Group 46.png'), btn: '去听课', item: '1' },
            teacherSubs: [
                { title: '区本课程', desc: '单元教学规划与实施', icon: require('../../assets/screen/Group 47.png'), item: '2' },
                { title: '校本课程', desc: '学科知识项目化学习', icon: require('../../assets/screen/Group 184.png'), item: '3' },
            ],
            teacherTools: [
                { title: '互动课件', desc: '快速生成习题', icon: require('../../assets/screen/Group 185.png'), item: '6' },
                { title: '精准助教', desc: '导航学习支持', icon: require('../../assets/screen/Group 186.png'), item: '7' },
            ],
            cloudCard: { title: '国家智慧教育云平台', desc: '协同备课与听评课相结合', icon: require('../../assets/screen/Group 187.png'), item: '9' },
            khfwCard: { title: '课后服务', item: '4' },
            levelCards: [
                { title: '小学资源', desc: '启蒙基础奠基', icon: require('../../assets/screen/Group 144.png'), item: '27' },
                { title: '初中资源', desc: '衔接思维拓展', icon: require('../../assets/screen/Group 147.png'), item: '28' },
                { title: '高中资源', desc: '深度构建未来', icon: require('../../assets/screen/Group 148.png'), item: '29' },
            ],
            /*学生成长中心（未对接的模块统一提示敬请期待）*/
            studentSingles: [
                { title: '自习室', btn: '去体验', item: '1', iconClass: 'icon-aplus', iconText: 'A' },
                { title: '作业管理', btn: '去体验', external: 'https://orgzuoye.slilm.com/', iconClass: 'icon-paddle' },
            ],
            studentVertical: [
                { title: '圈考点', btn: '去看看', item: '37' },
                { title: '热搜题', btn: '去看看', item: '38' },
                { title: '分层作业', btn: '去看看', item: '39' },
                { title: '英语强化', btn: '去看看', item: '40' },
            ],
            studentWide: { title: '闻题鸟', btn: '去看看', tip: true, iconClass: 'icon-book' },
            studentPlans: [
                { title: '赢在录取', btn: '去看看', item: '42', iconClass: 'icon-orange-num', iconText: '2+2' },
                { title: '赢在规划', btn: '去看看', item: '41', titleClass: 'title-brown', iconClass: 'icon-books' },
                { title: '学能规划', btn: '去看看', tip: true, iconClass: 'icon-calc' },
            ],
        }
    },
    computed: {},
    watch: {},
    created() {
        this.userInfo = JSON.parse(this.$storage.get("userInfo"))
        const p = this.$store.state.params.jumpParams || {}
        if (p.courseId){
            //课程详情直达：进入对应资源模块，由模块组件读取 courseId 展示详情
            this.activeItem = (p.activeItem && p.activeItem!=='99') ? p.activeItem : '2';
            this.activeTab = this.tabOfItem(this.activeItem);
            this.viewMode = 'module';
        } else if (p.activeTab && ['school', 'teacher', 'student'].includes(p.activeTab)) {
            this.activeTab = p.activeTab;
        } else if (p.activeItem) {
            this.activeTab = this.tabOfItem(p.activeItem);
        }
        this.$store.commit("params/setJumpParams", {});
    },
    mounted() {
        this.$refs.homeHead.activePath = this.activePath;
    },
    methods: {
        /*模块所属中心Tab*/
        tabOfItem(item){
            if (['10','11','8','12','13','14','20','15','30','31','32','33','34','35','43'].includes(item)) return 'school';
            if (['4','36','37','38','39','40','41','42'].includes(item)) return 'student';
            return 'teacher';
        },
        /*卡片点击*/
        openCard(c){
            if (c.tip){
                this.$message({ message: '功能即将上线，敬请期待', type: 'info' });
                return;
            }
            if (c.external){
                window.open(c.external, '_blank');
                return;
            }
            this.openItem(c.item);
        },
        /*进入资源模块（含外链跳转，逻辑同原 changeItem）*/
        openItem(item){
            if (item==='7'){
                if (!this.userInfo.isAide) {
                    this.$message.error("暂无权限")
                } else {
                    oauthCode({
                        clientId: 'xhly2024855631', username: this.userInfo.username
                    }).then(res => {
                        if (res.data.data) {
                            window.open('https://web.edumate.cn/thirdpart?platform=sxdtjz&code=' + res.data.data + '&client_id=xhly2024855631&response_type=code', '_blank')
                        } else {
                            this.$message.error("授权失败")
                        }
                    })
                }
                return;
            }
            if (item==='9'){
                window.open('https://basic.smartedu.cn/', '_blank')
                return;
            }
            if (item==='21'){
                window.open('http://www.xj5u.com/Handler/Login.ashx?ticket=hengyuejy', '_blank')
                return;
            }
            if (item==='22'){
                window.open('http://www.zk5u.com/Handler/Login.ashx?ticket=hengyuejy', '_blank')
                return;
            }
            if (item==='23'){
                window.open('https://apistore.ks5u.com/?GUID=7618FCD48C4D02AF0D256BBAFAB0C3BC&TYPE=NEW', '_blank')
                return;
            }
            if (item==='26'){
                window.open('https://chs.xwjyd.com/mall/subpages/mall/pages/shelves/shelves?sid=100104848&id=97289&advId=15073107777&promote=15073107777', '_blank')
                return;
            }
            if (item==='27'||item==='28'||item==='29'){
                let sp = "1";
                if (item==='28'){
                    sp = "2";
                }
                if (item==='29'){
                    sp = "3";
                }
                this.$router.push({
                    path: "/jzedu/ques",
                    query: {
                        sp: sp,
                    }
                });
                return;
            }
            this.activeItem = item;
            this.activeMode = this.pageMode;
            /*记录来源Tab，返回时回到原中心（如：学生中心-自习室打开高水平示范课）*/
            this.fromTab = this.activeTab;
            this.viewMode = 'module';
            this.$store.commit("params/setJumpParams", {});
        },
        /*返回卡片导航*/
        backToCards(){
            /*学生中心模块详情/预览中：顶部返回先回到模块列表*/
            const moduleRefs = {
                '37': ['examPointHome', 'view'],
                '38': ['hotQuesHome', 'view'],
                '39': ['homeworkHome', 'view'],
                '40': ['englishImproveHome', 'detail'],
                '41': ['admissionHome', 'view'],
                '42': ['winEnrollHome', 'view'],
                '43': ['materialHome', 'view'],
            };
            const conf = moduleRefs[this.activeItem];
            const moduleHome = conf && this.$refs[conf[0]];
            if (moduleHome && moduleHome.showMode === conf[1]) {
                moduleHome.backList();
                return;
            }
            this.viewMode = 'cards';
            this.activeTab = this.fromTab || this.tabOfItem(this.activeItem);
        },
        changeMode(mode){
            this.activeMode = mode;
        }
    }
}
</script>
<style lang="scss" scoped>
.container {
    width: 100%;
    height: 100vh;
    margin: 0;
    overflow-y: auto;
    overflow-x: hidden;
}

.rc-page {
    min-height: 100vh;
    box-sizing: border-box;
    padding: 100px 40px 20px;
    background: url("../../assets/screen/homeBg.png") no-repeat center center;
    background-size: cover;
}

/*中心切换 Tab*/
.tab-row {
    display: flex;
    gap: 16px;
    max-width: 1840px;
    margin: 0 auto 24px;
}

.tab-pill {
    height: 38px;
    line-height: 38px;
    padding: 0 22px;
    border-radius: 19px;
    background: #ffffff;
    border: 1px solid #ff7f2e;
    color: #ff7f2e;
    font-size: 16px;
    cursor: pointer;
}

.tab-active {
    background: #ff7f2e;
    border-color: #ff7f2e;
    color: #ffffff;
}

/*蓝色面板：高度随视口固定，内容超出时内部弹性收缩*/
.panel {
    display: flex;
    flex-direction: column;
    max-width: 1840px;
    margin: 0 auto;
    background: #c9e5fc;
    border-radius: 28px;
    padding: 26px 28px 30px;
    box-sizing: border-box;
    height: calc(100vh - 182px);
    min-height: 0;
}

.panel-title {
    flex-shrink: 0;
    text-align: center;
    font-size: 24px;
    font-weight: 700;
    color: #1d63b8;
    margin-bottom: 24px;

    .star {
        margin-right: 8px;
    }
}

.panel-title-left {
    text-align: left;
}

/*白色竖卡片*/
.sc-card {
    position: relative;
    display: flex;
    flex-direction: column;
    min-height: 0;
    overflow: hidden;
    background: #ffffff;
    border-radius: 24px;
    padding: 30px 26px;
    box-sizing: border-box;
    cursor: pointer;
    transition: transform .2s ease;
}

.sc-card:hover {
    transform: translateY(-4px);
}

.sc-title {
    flex-shrink: 0;
    font-size: 20px;
    font-weight: 700;
    color: #17365d;
    line-height: 1.4;
}

.sc-desc {
    flex-shrink: 0;
    font-size: 15px;
    color: #8a97a8;
    margin-top: 10px;
    line-height: 1.6;
}

.sc-icon {
    display: block;
    flex: 1;
    min-height: 0;
    width: 150px;
    object-fit: contain;
    margin: 8px auto;
}

.text-center {
    text-align: center;
}

/*蓝色胶囊按钮（底部深色描边）*/
.pill-btn {
    flex-shrink: 0;
    margin-top: auto;
    align-self: center;
    width: 160px;
    height: 44px;
    line-height: 44px;
    text-align: center;
    color: #ffffff;
    font-size: 16px;
    border-radius: 22px;
    background: linear-gradient(180deg, #5cb3f7, #4098ec);
    box-shadow: 0 5px 0 #2f7fd0;
    cursor: pointer;
}

.pill-btn:active {
    transform: translateY(3px);
    box-shadow: 0 2px 0 #2f7fd0;
}

.pill-btn-sm {
    width: 120px;
    height: 36px;
    line-height: 36px;
    font-size: 14px;
    margin-top: 24px;
    align-self: flex-start;

    .arr {
        margin-left: 6px;
    }
}

/*热门角标*/
.hot-tag {
    display: inline-block;
    margin-left: 10px;
    padding: 2px 8px;
    font-size: 12px;
    font-weight: 400;
    color: #ffffff;
    background: #ff6b4a;
    border-radius: 4px;
    vertical-align: middle;
}

/*学校文化中心*/
.school-card-row {
    flex: 1;
    min-height: 0;
    display: flex;
    gap: 28px;

    .sc-card {
        flex: 1;
    }
}

/*教师发展中心*/
.teacher-wrap {
    display: flex;
    gap: 28px;
    max-width: 1840px;
    margin: 0 auto;
    height: calc(100vh - 182px);
    min-height: 0;

    .teach-panel {
        flex: 1;
        margin: 0;
        height: auto;
        min-height: 0;
    }

    .teach-right {
        flex: 1.03;
        display: flex;
        flex-direction: column;
        gap: 28px;
        min-height: 0;
    }
}

.teach-grid {
    flex: 1;
    min-height: 0;
    display: flex;
    gap: 24px;

    .gsp-card {
        flex: 1;
    }

    .teach-sub {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 24px;
        min-height: 0;

        .sub-card {
            flex: 1;
            min-height: 0;
            padding: 18px 22px;

            .sub-icon {
                display: block;
                flex: 1;
                min-height: 0;
                width: 110px;
                object-fit: contain;
                margin: 8px auto 0;
            }
        }
    }
}

.tool-panel {
    flex-shrink: 0;
    display: flex;
    flex-direction: row;
    gap: 24px;
    margin: 0;
    padding: 22px;
    height: auto;
    min-height: 0;

    .tool-card {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #ffffff;
        border-radius: 20px;
        padding: 20px 26px;
        cursor: pointer;
        transition: transform .2s ease;

        &:hover {
            transform: translateY(-4px);
        }

        .tool-icon {
            width: 76px;
            margin-left: 16px;
        }
    }
}

.teach-bottom {
    flex: 1;
    min-height: 0;
    display: flex;
    gap: 28px;

    /*国家智慧教育云平台 + 课后服务（上下两部分）*/
    .cloud-col {
        flex: 1;
        min-height: 0;
        display: flex;
        flex-direction: column;
        gap: 20px;
    }

    .cloud-card {
        flex: 1;
        min-height: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        /*文字内容下移，贴近卡片底部*/
        justify-content: flex-end;
        border-radius: 28px;
        padding: 30px;
        box-sizing: border-box;
        cursor: pointer;
        background: url("../../assets/screen/gjzhypt_bg.png") no-repeat center center;
        background-size: 100% 100%;
        transition: transform .2s ease;
        overflow: hidden;

        &:hover {
            transform: translateY(-4px);
        }

        .cloud-title {
            flex-shrink: 0;
            font-size: 22px;
            font-weight: 700;
            color: #17365d;
            text-align: center;
        }

        .cloud-desc {
            flex-shrink: 0;
            font-size: 15px;
            color: #4a6a8a;
            margin-top: 10px;
            text-align: center;
        }
    }

    /*课后服务（背景图 + 文字，点击打开学生成长中心的课后服务）*/
    .khfw-card {
        flex: 1;
        min-height: 0;
        display: flex;
        /*文字内容上移，贴近卡片顶部*/
        align-items: flex-start;
        border-radius: 28px;
        padding: 8% 8% 0;
        box-sizing: border-box;
        cursor: pointer;
        background: url("../../assets/screen/khfw_bg.png") no-repeat center center;
        background-size: 100% 100%;
        transition: transform .2s ease;
        overflow: hidden;

        &:hover {
            transform: translateY(-4px);
        }

        .khfw-title {
            font-size: 22px;
            font-weight: 700;
            color: #17365d;
        }
    }

    .res-col {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 20px;
        min-height: 0;

        .res-card {
            flex: 1;
            min-height: 0;
            display: flex;
            align-items: center;
            justify-content: space-between;
            background: #ffffff;
            border-radius: 20px;
            padding: 12px 20px;
            cursor: pointer;
            transition: transform .2s ease;

            &:hover {
                transform: translateY(-4px);
            }

            .res-icon {
                width: 56px;
                margin-left: 16px;
            }
        }
    }
}

/*学生成长中心*/
.student-wrap {
    display: flex;
    gap: 28px;
    max-width: 1840px;
    margin: 0 auto;
    height: calc(100vh - 182px);
    min-height: 0;

    .stu-card {
        flex: 1;
        /*窗口缩小时保持占比，不被右侧面板挤压*/
        min-width: 0;

        .stu-icon-wrap {
            flex: 1;
            min-height: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 8px 0;
        }
    }

    .stu-panel {
        flex: 3;
        margin: 0;
        height: auto;
        min-height: 0;
        /*窗口缩小时允许面板压缩，保持与左侧卡片的占比*/
        min-width: 0;
        display: flex;
        flex-direction: column;
        gap: 24px;
    }
}

.stu-top {
    flex: 1;
    min-height: 0;
    min-width: 0;
    display: flex;
    gap: 24px;
}

.stu-bottom {
    flex: 1;
    min-height: 0;
    min-width: 0;
    display: flex;
    gap: 24px;
}

/*竖排文字小卡片*/
.stu-v-card {
    flex: 1;
    min-height: 0;
    min-width: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #ffffff;
    border-radius: 20px;
    padding: 22px 10px 20px;
    box-sizing: border-box;
    cursor: pointer;
    transition: transform .2s ease;

    &:hover {
        transform: translateY(-4px);
    }

    .stu-v-title {
        flex: 1;
        min-height: 0;
        writing-mode: vertical-rl;
        letter-spacing: 8px;
        font-size: 20px;
        font-weight: 700;
        color: #17365d;
        overflow: hidden;
    }
}

/*闻题鸟宽卡片*/
.stu-wide-card {
    flex: 2.4;
    min-height: 0;
    min-width: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    background: #ffffff;
    border-radius: 20px;
    padding: 24px 28px 20px;
    box-sizing: border-box;
    cursor: pointer;
    transition: transform .2s ease;

    &:hover {
        transform: translateY(-4px);
    }

    .stu-wide-title {
        flex-shrink: 0;
        font-size: 20px;
        font-weight: 700;
        color: #2f9be8;
        text-align: center;
    }
}

/*赢在录取 / 赢在规划 / 学能规划*/
.stu-plan-card {
    flex: 1;
    min-height: 0;
    min-width: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    background: #ffffff;
    border-radius: 20px;
    padding: 24px 28px 20px;
    box-sizing: border-box;
    cursor: pointer;
    transition: transform .2s ease;

    &:hover {
        transform: translateY(-4px);
    }

    .stu-plan-title {
        flex-shrink: 0;
        font-size: 20px;
        font-weight: 700;
        color: #17365d;
        text-align: center;

        &.title-brown {
            color: #b07d1e;
        }
    }
}

/*按钮 + 图标底排*/
.stu-card-bottom {
    flex: 1;
    min-height: 0;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 12px;
}

/*小胶囊按钮*/
.pill-btn-xs {
    flex-shrink: 0;
    align-self: center;
    width: auto;
    height: 30px;
    line-height: 30px;
    padding: 0 14px;
    text-align: center;
    color: #ffffff;
    font-size: 13px;
    border-radius: 15px;
    background: linear-gradient(180deg, #5cb3f7, #4098ec);
    box-shadow: 0 4px 0 #2f7fd0;
    cursor: pointer;

    .arr {
        margin-left: 4px;
    }
}

.pill-btn-xs:active {
    transform: translateY(2px);
    box-shadow: 0 2px 0 #2f7fd0;
}

/*CSS 绘制图标*/
.stu-icon {
    position: relative;
    flex-shrink: 0;
}

/*自习室：蓝色 A+ 徽章*/
.icon-aplus {
    width: 110px;
    height: 110px;
    border-radius: 24px;
    background: linear-gradient(135deg, #4fd8f7, #3d8ef0);
    box-shadow: 0 8px 16px rgba(61, 142, 240, .35);
    color: #ffffff;
    font-size: 64px;
    font-weight: 700;
    line-height: 110px;
    text-align: center;

    &::after {
        content: '+';
        position: absolute;
        top: 12px;
        right: 14px;
        font-size: 34px;
        font-weight: 700;
        color: #ffffff;
    }
}

/*作业管理：乒乓球拍 + 球*/
.icon-paddle {
    width: 96px;
    height: 96px;
    border-radius: 50%;
    background: linear-gradient(135deg, #4fd8f7, #3d8ef0);
    box-shadow: 0 8px 16px rgba(61, 142, 240, .35);

    /*拍柄*/
    &::before {
        content: '';
        position: absolute;
        left: 50%;
        bottom: -38px;
        width: 18px;
        height: 52px;
        margin-left: -9px;
        border-radius: 9px;
        background: linear-gradient(180deg, #3d8ef0, #2f7fd0);
        transform: rotate(32deg);
        transform-origin: top center;
    }

    /*橙色小球*/
    &::after {
        content: '';
        position: absolute;
        right: -22px;
        bottom: -16px;
        width: 34px;
        height: 34px;
        border-radius: 50%;
        background: linear-gradient(135deg, #ffb35c, #ff8a3d);
        box-shadow: 0 4px 8px rgba(255, 138, 61, .4);
    }
}

/*闻题鸟：蓝色书本*/
.icon-book {
    width: 64px;
    height: 76px;
    border-radius: 8px 14px 14px 8px;
    background: linear-gradient(135deg, #4fd8f7, #3d8ef0);
    box-shadow: 0 6px 12px rgba(61, 142, 240, .35);

    /*书脊*/
    &::before {
        content: '';
        position: absolute;
        left: 10px;
        top: 0;
        bottom: 0;
        width: 5px;
        background: rgba(255, 255, 255, .55);
        border-radius: 3px;
    }

    /*书页底纹*/
    &::after {
        content: '';
        position: absolute;
        left: 24px;
        right: 12px;
        bottom: 12px;
        height: 6px;
        border-radius: 3px;
        background: #ffb35c;
    }
}

/*赢在录取：橙色 2+2 徽章*/
.icon-orange-num {
    width: 74px;
    height: 74px;
    border-radius: 16px;
    background: linear-gradient(135deg, #ffc46b, #ff8a3d);
    box-shadow: 0 6px 12px rgba(255, 138, 61, .35);
    color: #ffffff;
    font-size: 28px;
    font-weight: 700;
    line-height: 74px;
    text-align: center;
}

/*赢在规划：两本书*/
.icon-books {
    width: 74px;
    height: 76px;

    &::before,
    &::after {
        content: '';
        position: absolute;
        bottom: 0;
        width: 26px;
        border-radius: 6px;
    }

    &::before {
        left: 8px;
        height: 72px;
        background: linear-gradient(180deg, #ffc46b, #ff9a3d);
        box-shadow: 0 6px 12px rgba(255, 154, 61, .35);
    }

    &::after {
        left: 40px;
        height: 62px;
        background: linear-gradient(180deg, #ff8a6b, #f2553d);
        transform: rotate(10deg);
        transform-origin: bottom center;
        box-shadow: 0 6px 12px rgba(242, 85, 61, .3);
    }
}

/*学能规划：橙色计算器*/
.icon-calc {
    width: 74px;
    height: 74px;
    border-radius: 16px;
    background: linear-gradient(135deg, #ffc46b, #ff8a3d);
    box-shadow: 0 6px 12px rgba(255, 138, 61, .35);

    &::before {
        content: '+ －\A × ＝';
        white-space: pre;
        position: absolute;
        inset: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ffffff;
        font-size: 22px;
        font-weight: 700;
        line-height: 1.5;
        text-align: center;
    }
}

.kh-info {
    .kh-title {
        font-size: 20px;
        font-weight: 700;
        color: #17365d;
    }

    .kh-desc {
        font-size: 16px;
        color: #8a97a8;
        margin-top: 10px;
    }
}

/*模块视图*/
.back-row {
    position: relative;
    display: flex;
    align-items: center;
    max-width: 1840px;
    margin: 0 auto 16px;
}

/*与返回按钮同行的模块标题（圈考点）*/
.back-row-title {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    font-size: 22px;
    font-weight: 700;
    color: #ff7f2e;
    /*color: #1d63b8;*/

    .star {
        margin-right: 8px;
    }
}

/*返回行右侧的子模块Tab（赢在录取）*/
.back-row-tabs {
    margin-left: auto;
    display: flex;
    gap: 12px;

    .tab-pill {
        height: 34px;
        line-height: 34px;
        font-size: 15px;
    }
}

.back-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 38px;
    padding: 0 20px;
    border-radius: 19px;
    background: #ffffff;
    border: 1px solid #ff7f2e;
    color: #ff7f2e;
    font-size: 15px;
    cursor: pointer;

    &:hover {
        background: #ff7f2e;
        border-color: #ff7f2e;
        color: #ffffff;
    }
}

.module-content {
    max-width: 1840px;
    margin: 0 auto;
    min-height: calc(100vh - 174px);
    box-sizing: border-box;
}

/*矮屏紧凑适配：防止卡片内容超出固定高度面板*/
@media screen and (max-height: 800px) {
    .panel {
        padding: 18px 22px 22px;
    }

    .panel-title {
        font-size: 20px;
        margin-bottom: 14px;
    }

    .sc-card {
        padding: 20px 22px;
    }

    .sc-title {
        font-size: 18px;
    }

    .sc-desc {
        font-size: 14px;
        margin-top: 6px;
    }

    .pill-btn {
        width: 140px;
        height: 38px;
        line-height: 38px;
        font-size: 14px;
    }

    .pill-btn-sm {
        width: 110px;
        height: 32px;
        line-height: 32px;
        font-size: 13px;
        margin-top: 12px;
    }

    .pill-btn-xs {
        /*覆盖 .pill-btn 在本媒体查询中的 140px 宽度，保持自适应*/
        width: auto;
        height: 26px;
        line-height: 26px;
        font-size: 12px;
        padding: 0 10px;
    }

    .stu-v-card,
    .stu-wide-card,
    .stu-plan-card {
        padding-top: 14px;
        padding-bottom: 12px;
    }

    .stu-v-card .stu-v-title {
        font-size: 17px;
    }

    .stu-wide-card .stu-wide-title,
    .stu-plan-card .stu-plan-title {
        font-size: 17px;
    }

    .kh-info {
        .kh-title {
            font-size: 18px;
        }

        .kh-desc {
            font-size: 14px;
            margin-top: 6px;
        }
    }

    .tool-panel {
        padding: 16px;

        .tool-card {
            padding: 14px 20px;
        }
    }

    .cloud-card {
        padding: 20px 24px;
    }
}

/*窄屏适配：缩小底排按钮与图标，防止溢出卡片*/
@media screen and (max-width: 1600px) {
    .stu-wide-card,
    .stu-plan-card {
        padding-left: 16px;
        padding-right: 16px;
    }

    .stu-card-bottom {
        .pill-btn-xs {
            padding: 0 10px;
            font-size: 12px;
        }

        .stu-icon {
            transform: scale(.75);
            transform-origin: bottom right;
        }
    }
}
</style>
